export default __webpack_public_path__ + "static/media/HermosoClosed.acd1bf1f.jpg";